/**
 * 页面模板库
 * 根据文本描述生成对应的页面模板
 */

/**
 * 登录页面模板
 */
export function generateLoginTemplate(): string {
  return `<!DOCTYPE html>
<html lang="zh-CN">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>登录</title>
  <style>
    * { box-sizing: border-box; }
    body {
      font-family: system-ui, -apple-system, sans-serif;
      margin: 0;
      min-height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    }
    .login-box {
      background: white;
      padding: 40px;
      border-radius: 16px;
      box-shadow: 0 20px 60px rgba(0,0,0,0.3);
      width: 100%;
      max-width: 400px;
    }
    h2 {
      margin: 0 0 24px 0;
      color: #1f2937;
      font-size: 28px;
      text-align: center;
    }
    .form-group {
      margin-bottom: 20px;
    }
    label {
      display: block;
      margin-bottom: 8px;
      color: #4b5563;
      font-weight: 500;
    }
    input {
      width: 100%;
      padding: 12px 16px;
      border: 2px solid #e5e7eb;
      border-radius: 8px;
      font-size: 16px;
      transition: border-color 0.2s;
    }
    input:focus {
      outline: none;
      border-color: #667eea;
    }
    button {
      width: 100%;
      padding: 14px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: white;
      border: none;
      border-radius: 8px;
      font-size: 16px;
      font-weight: 600;
      cursor: pointer;
      transition: transform 0.1s, box-shadow 0.2s;
    }
    button:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba(102,126,234,0.4);
    }
    .links {
      margin-top: 20px;
      text-align: center;
      font-size: 14px;
    }
    .links a {
      color: #667eea;
      text-decoration: none;
    }
    .links a:hover {
      text-decoration: underline;
    }
  </style>
</head>
<body>
  <div class="login-box">
    <h2>欢迎登录</h2>
    <form>
      <div class="form-group">
        <label>用户名</label>
        <input type="text" placeholder="请输入用户名" />
      </div>
      <div class="form-group">
        <label>密码</label>
        <input type="password" placeholder="请输入密码" />
      </div>
      <button type="submit">登录</button>
    </form>
    <div class="links">
      <a href="#">忘记密码?</a> · <a href="#">注册账号</a>
    </div>
  </div>
</body>
</html>`;
}

/**
 * 注册页面模板
 */
export function generateRegisterTemplate(): string {
  return `<!DOCTYPE html>
<html lang="zh-CN">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>注册</title>
  <style>
    * { box-sizing: border-box; }
    body {
      font-family: system-ui, -apple-system, sans-serif;
      margin: 0;
      min-height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
    }
    .register-box {
      background: white;
      padding: 40px;
      border-radius: 16px;
      box-shadow: 0 20px 60px rgba(0,0,0,0.3);
      width: 100%;
      max-width: 420px;
    }
    h2 {
      margin: 0 0 24px 0;
      color: #1f2937;
      font-size: 28px;
      text-align: center;
    }
    .form-group {
      margin-bottom: 16px;
    }
    label {
      display: block;
      margin-bottom: 6px;
      color: #4b5563;
      font-weight: 500;
      font-size: 14px;
    }
    input {
      width: 100%;
      padding: 10px 14px;
      border: 2px solid #e5e7eb;
      border-radius: 8px;
      font-size: 15px;
      transition: border-color 0.2s;
    }
    input:focus {
      outline: none;
      border-color: #11998e;
    }
    button {
      width: 100%;
      padding: 14px;
      background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
      color: white;
      border: none;
      border-radius: 8px;
      font-size: 16px;
      font-weight: 600;
      cursor: pointer;
      margin-top: 10px;
    }
    button:hover {
      opacity: 0.9;
    }
    .login-link {
      margin-top: 20px;
      text-align: center;
      font-size: 14px;
      color: #6b7280;
    }
    .login-link a {
      color: #11998e;
      text-decoration: none;
      font-weight: 500;
    }
  </style>
</head>
<body>
  <div class="register-box">
    <h2>创建账号</h2>
    <form>
      <div class="form-group">
        <label>用户名</label>
        <input type="text" placeholder="设置用户名" />
      </div>
      <div class="form-group">
        <label>邮箱</label>
        <input type="email" placeholder="your@email.com" />
      </div>
      <div class="form-group">
        <label>密码</label>
        <input type="password" placeholder="设置密码" />
      </div>
      <div class="form-group">
        <label>确认密码</label>
        <input type="password" placeholder="再次输入密码" />
      </div>
      <button type="submit">注册</button>
    </form>
    <div class="login-link">
      已有账号? <a href="#">立即登录</a>
    </div>
  </div>
</body>
</html>`;
}

/**
 * 首页/Landing页面模板
 */
export function generateLandingTemplate(): string {
  return `<!DOCTYPE html>
<html lang="zh-CN">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>首页</title>
  <style>
    * { box-sizing: border-box; margin: 0; padding: 0; }
    body {
      font-family: system-ui, -apple-system, sans-serif;
      line-height: 1.6;
      color: #1f2937;
    }
    header {
      background: white;
      box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      padding: 1rem 5%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .logo {
      font-size: 24px;
      font-weight: bold;
      color: #2563eb;
    }
    nav a {
      margin-left: 2rem;
      color: #4b5563;
      text-decoration: none;
      font-weight: 500;
    }
    nav a:hover {
      color: #2563eb;
    }
    .hero {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: white;
      padding: 100px 5%;
      text-align: center;
    }
    .hero h1 {
      font-size: 48px;
      margin-bottom: 20px;
    }
    .hero p {
      font-size: 20px;
      margin-bottom: 40px;
      opacity: 0.9;
    }
    .cta-button {
      display: inline-block;
      padding: 16px 40px;
      background: white;
      color: #667eea;
      text-decoration: none;
      border-radius: 8px;
      font-weight: 600;
      font-size: 18px;
      transition: transform 0.2s, box-shadow 0.2s;
    }
    .cta-button:hover {
      transform: translateY(-2px);
      box-shadow: 0 10px 30px rgba(0,0,0,0.2);
    }
    .features {
      padding: 80px 5%;
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
      gap: 40px;
      max-width: 1200px;
      margin: 0 auto;
    }
    .feature {
      text-align: center;
      padding: 40px;
      background: #f9fafb;
      border-radius: 16px;
    }
    .feature-icon {
      width: 64px;
      height: 64px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      border-radius: 16px;
      margin: 0 auto 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      font-size: 28px;
    }
    .feature h3 {
      margin-bottom: 12px;
      color: #1f2937;
    }
    .feature p {
      color: #6b7280;
    }
    footer {
      background: #1f2937;
      color: white;
      text-align: center;
      padding: 40px 5%;
    }
  </style>
</head>
<body>
  <header>
    <div class="logo">Brand</div>
    <nav>
      <a href="#">首页</a>
      <a href="#">功能</a>
      <a href="#">价格</a>
      <a href="#">关于</a>
    </nav>
  </header>
  
  <section class="hero">
    <h1>欢迎来到我们的产品</h1>
    <p>简洁、高效、强大的解决方案，助力您的业务腾飞</p>
    <a href="#" class="cta-button">立即开始</a>
  </section>
  
  <section class="features">
    <div class="feature">
      <div class="feature-icon">⚡</div>
      <h3>极速体验</h3>
      <p>优化的性能，毫秒级响应，流畅的用户体验</p>
    </div>
    <div class="feature">
      <div class="feature-icon">🔒</div>
      <h3>安全可靠</h3>
      <p>企业级安全保障，数据加密传输，安心使用</p>
    </div>
    <div class="feature">
      <div class="feature-icon">🎨</div>
      <h3>精美设计</h3>
      <p>现代化界面设计，直观易用，提升工作效率</p>
    </div>
  </section>
  
  <footer>
    <p>&copy; 2024 Brand. All rights reserved.</p>
  </footer>
</body>
</html>`;
}

/**
 * 通用页面模板（兜底）
 */
export function generateGenericTemplate(description: string): string {
  return `<!DOCTYPE html>
<html lang="zh-CN">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>页面预览</title>
  <style>
    * { box-sizing: border-box; }
    body {
      font-family: system-ui, -apple-system, sans-serif;
      margin: 0;
      padding: 40px 20px;
      background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
      min-height: 100vh;
    }
    .container {
      max-width: 800px;
      margin: 0 auto;
      background: white;
      padding: 40px;
      border-radius: 16px;
      box-shadow: 0 4px 20px rgba(0,0,0,0.1);
    }
    h1 {
      color: #1f2937;
      margin-bottom: 20px;
    }
    p {
      color: #4b5563;
      line-height: 1.8;
    }
    .placeholder {
      background: #f3f4f6;
      border: 2px dashed #d1d5db;
      border-radius: 8px;
      padding: 60px 20px;
      text-align: center;
      color: #9ca3af;
      margin: 20px 0;
    }
  </style>
</head>
<body>
  <div class="container">
    <h1>页面预览</h1>
    <p>${description.replace(/</g, '&lt;').replace(/>/g, '&gt;')}</p>
    <div class="placeholder">
      <p>🎨 AI根据描述生成的示例页面</p>
      <p>您可以在左侧继续细化需求，获得更精确的页面</p>
    </div>
  </div>
</body>
</html>`;
}

/**
 * 根据关键词选择模板
 */
export function selectTemplateByKeywords(keywords: string[], description: string): string {
  if (keywords.includes('login')) {
    return generateLoginTemplate();
  }
  if (keywords.includes('register')) {
    return generateRegisterTemplate();
  }
  if (keywords.includes('landing') || keywords.includes('home')) {
    return generateLandingTemplate();
  }
  return generateGenericTemplate(description);
}
